import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, Checkbox, FormControl } from 'react-bootstrap';
import { getMaterialsWithCheck } from './../services/arrayServices'

const MATERIALS = "materials"

class Overig extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        if (name === MATERIALS)
            this.props.onWorkAreasChange(target.value, target.checked)
        //this.setState({ [MATERIALS.value]: target.checked })

        else {
            const value = target.type === "checkbox" ? target.checked : target.value
            this.props.onChange(name, value)
        }

    }

    render() {
        const data = this.props.data
        const materials = this.props.materials

        return (
            <div>
                <h5>Overig</h5>
                <FormGroup controlId="AccountContributie">
                    <Col componentClass={ControlLabel} sm={4}>
                        Contributie
                    </Col>
                    <Col sm={6}>
                        <FormControl componentClass="select" placeholder="" name="subscriptionType" value={data.subscriptionType} onChange={this.handleChange}>
                            <option value="0">Zelf betalen</option>
                            <option value="1">Werkgever betaalt</option>
                        </FormControl>
                    </Col>
                </FormGroup>
                <hr />
                <FormGroup controlId="AccountWerkgebieden">
                    <Col componentClass={ControlLabel} sm={4}>
                        Werkgebieden
                </Col>
                    <Col sm={6}>
                        {materials && Object.keys(materials).length !== 0 ?
                            getMaterialsWithCheck(materials, data.materials, this.handleChange) : null
                        }
                    </Col>
                </FormGroup>
                <hr />
                <FormGroup controlId="AccountNieuwsbrief">
                    <Col componentClass={ControlLabel} sm={4}>
                        Nieuwsbrief
                </Col>
                    <Col sm={6}>
                        <Checkbox name="newsletter" checked={data.newsletter} onChange={this.handleChange}>Ja, ik wil graag de nieuwsbrief ontvangen</Checkbox>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

export default Overig;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Account/Overig.js